import React from 'react';
import {Font,StyleSheet, View, Text } from '@react-pdf/renderer';
import styles from '../../Transcript/TranscriptStyles';
import { formatDate,formatInstructorName } from '../../Transcript/TranscriptUtils';

// Font.register({
//   family: 'NotoSans',
//   src: 'https://cdn.jsdelivr.net/npm/@fontsource/noto-sans/files/noto-sans-latin-400-normal.woff',
// });

// Font.register({
//   family: 'NotoSansCyrillic',
//   src: 'https://cdn.jsdelivr.net/npm/@fontsource/noto-sans/files/noto-sans-cyrillic-400-normal.woff',
// });

Font.register({
  family: 'NotoEthiopic',
  src: '/fonts/NotoSansEthiopic-Regular.ttf',
});
Font.register({
  family: 'NotoSans',
  src: '/fonts/NotoSans-Regular.ttf',
});
Font.register({
  family: 'NotoSansDevanagari',
  src: '/fonts/NotoSansDevanagari-Regular.ttf',
});
Font.register({
  family: 'NotoSansSC',
  src: '/fonts/NotoSansSC-Regular.ttf',
});
Font.register({
  family: 'NotoSansKR',
  src: '/fonts/NotoSansKR-Regular.ttf',
});
Font.register({
  family: 'NotoSansArabic',
  src: '/fonts/NotoSansArabic-Regular.ttf',
});
Font.register({
  family: 'NotoSansKhmer',
  src: '/fonts/NotoSansKhmer-Regular.ttf',
});
Font.register({
  family: 'NotoCombo',
  fonts: [
    { src: '/fonts/NotoSans-Regular.ttf' },
    { src: '/fonts/NotoSansKR-Regular.ttf'},
  ],
});

const detectFont = text => {
    // Korean (Hangul)
    if (/[\uAC00-\uD7AF]/.test(text)) return 'NotoSansKR';

    // Chinese (Simplified + Traditional)
    if (/[\u4E00-\u9FFF]/.test(text)) return 'NotoSansSC';

    // Devanagari (Hindi, Marathi, etc.)
    if (/[\u0900-\u097F]/.test(text)) return 'NotoSansDevanagari';

    // Arabic
    if (/[\u0600-\u06FF]/.test(text)) return 'NotoSansArabic';

    // Ethiopic (Tigrinya, Amharic)
    if (/[\u1200-\u137F]/.test(text)) return 'NotoEthiopic';

    // Khmer
    if (/[\u1780-\u17FF]/.test(text)) return 'NotoSansKhmer';

    // Vietnamese (Latin + diacritics)
    if (/[\u0100-\u017F]/.test(text)) return 'NotoSans';

    // Basic Latin (English, Somali, etc.)
    if (/[\u0000-\u007F]/.test(text)) return 'NotoSans';

    // Default fallback
    return 'NotoSans';
};
const TranscriptTable = ({ chunk }) => (
  <>
    <View style={[styles.tableRow1, styles.tableHeader]}>
      <Text style={[styles.tableCell, styles.completed]}>COMPLETED</Text>
       <Text style={[styles.tableCell, styles.courseName]}   hyphenationCallback={word => [word]}>COURSE NAME</Text> 
     

       <Text style={[styles.tableCell, styles.language]}>LANGUAGE</Text>
      <Text style={[styles.tableCell, styles.courseCode]}>COURSE CODE</Text>
      <Text style={[styles.tableCell, styles.program]}>PROGRAM*</Text>
      <Text style={[styles.tableCell, styles.hours]}>HOURS</Text>
      <Text style={[styles.tableCell, styles.courseType]}>COURSE TYPE</Text>
      <Text style={[styles.tableCell, styles.instructor]}>INSTRUCTOR</Text>
    </View>
    {chunk && chunk.length > 0 ? (
chunk.map((item, i) => (
      <View key={i} style={styles.tableRow}>
        <Text style={[styles.tableCell, styles.completed]}>{formatDate(item.completeddate)}</Text>
        {/* <Text style={[styles.tableCell, styles.courseName,{ fontFamily: 'NotoSans' }]}>{item.coursename}</Text> */}
         <Text
    style={[styles.tableCell, styles.courseName,{ fontFamily: detectFont(item.coursename)}]}
    wrap
     lang="de"  
    hyphenationCallback={word => [word]}
  >
    {item.coursename}
  </Text>

        <Text style={[styles.tableCell, styles.language]}>{item.courselanguage}</Text>
        <Text style={[styles.tableCell, styles.courseCode]}>{item.dshscourseid}</Text>
        <Text style={[styles.tableCell, styles.program]}>{item.trainingprogramcode}</Text>
        <Text style={[styles.tableCell, styles.hours]}>{item.credithours}</Text>
        <Text style={[styles.tableCell, styles.courseType]}>{item.coursetypename}</Text>
        <Text style={[styles.tableCell, styles.instructor]} wrap 
    hyphenationCallback={word => [word]}>{formatInstructorName(item.instructorname)}</Text>
      </View>
   ))
) : (
  <Text  style={{ textAlign: 'center', marginTop: 10 }}>No records found.</Text>
)}
  </>
);

export default TranscriptTable;
